import React from 'react'
import Loadersspinners from "./Loaders/LoadersSpinners";
import { Link , useNavigate} from 'react-router-dom'
import { useState } from 'react'
import axios from 'axios';
import { useDispatch } from 'react-redux' 
import { adminlog, userlog, setuserid, setuserdata  } from '../features/auth';
import { cartItem } from '../features/cartdata';
import { useSnackbar } from 'notistack';
import { Baseurl } from '../constants/env';
import Button from 'react-bootstrap/esm/Button';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const[Loading,setLoading]=useState(false);
   const [Username,setUsername] = useState();
    const [Password,setPassword] = useState();
   //const [resp,setResp] = useState();

    const {enqueueSnackbar} = useSnackbar();


  async function Data(e){
    e.preventDefault();
    setLoading(true)
    let data = {
      username:Username,
      password:Password
    }
   await axios.post(`${Baseurl}/login`,data ,{ withCredentials: true }).then(async (resp)=>{
    //console.log(resp );
    //setResp(resp);
    
    setLoading(false)
   
    if(resp.data.admin === "adminok"){
      //localStorage.setItem('admin','1');
      dispatch(adminlog(true));
      return navigate('/admin', { replace: true } )
    }else if(resp.data.user === "userok"){
      dispatch(setuserdata(resp.data.data))
      localStorage.setItem('userdata',resp.data.cartlength)
      await axios(`${Baseurl}/cart?id=${resp.data.data?._id}`,{ withCredentials: true }).then((resp)=>{
        setLoading(true);
         dispatch(cartItem(resp.data.cartlength));
         localStorage.setItem('cart',resp.data.cartlength)
         setLoading(false);
      }).catch((e)=>{
        setLoading(false);
        enqueueSnackbar('Something Wrong ' + e.mesaage ,{variant:'error'})
        console.log(e.mesaage);
      });
localStorage.setItem('token',resp.data?.accessToken)
localStorage.setItem('id',resp.data?.id)
       //localStorage.setItem('user','1');
      dispatch(setuserid(resp.data.id))
      dispatch(userlog(true));
      enqueueSnackbar('Welcome '+ resp?.data?.data?.firstname,{variant:'info'})
      return  navigate('/', { replace: true } )
      }else{
      return navigate('/login', { replace: true } )
    }

    }).catch((err)=>{
    console.log(err);
    setLoading(false)
    // enqueueSnackbar('Error '+ err.response.data.message,{variant:'warning'})

   });
 }


  return (
    //  <div style={{backgroundColor:'violet',width:'100%',height:'100vh',display:'flex',justifyContent:'center',alignItems:'center',flexWrap:'wrap'}}>
    
    <div>

<main className="main">
<section class="section-contact-us">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                <li class="breadcrumb-item active" aria-current="page">
                  Login
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="contact-form register-form text-center">
              <h3 class="mb-0">Welcome back!</h3>
              <p>Enter your details below.</p>

              <form>
                <div class="mb-3 mt-5">
                  <input value={Username} onChange={(e)=>{setUsername(e.target.value)}} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Email" />
                </div>
                <div class="mb-3">
                  <input value={Password} onChange={(e)=>{setPassword(e.target.value)}}  type="password" class="form-control" id="exampleFormControlInput1" placeholder="Password" />
                </div>
               
              
                <div class="mb-3 text-end">
             <p class="text-end"> <Link to='/forgotpassword'> Forgot Password? </Link> </p>
                </div>

                <button type="submit" onClick={Data} class="btn btn-primary-theme d-block w-100 mb-4">
                  Login
                </button>

                <p>Don’t have an account? <Link to="/register">Register now! </Link> </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>









</main>


      
          {/* <form name='loginform' method='post' className='login__form' onSubmit={Data} style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
          <h1 className='login__h1 text-white' style={{}}>Log In</h1>
          <input type='text' className='login__input text-center' placeholder='Username'
            style={{padding:'4px',border:'1px solid white',borderRadius:'12px'}}></input>
          
          <input type='Password' className='login__password text-center' placeholder='Password'
           style={{padding:'4px',marginTop:'7px',border:'1px solid white',borderRadius:'12px'}}></input>
    
          <Button type='submit' disabled={Loading} className='login__btn' style={{marginTop:'15px',border:'1px solid white',borderRadius:'12px'}} >Submit</Button>
        
        </form>
        <div><Button style={{border:'1px solid white',borderRadius:'12px'}}><Link className='text-white' style={{textDecoration:'none'}} to='/'>Back Home</Link></Button></div> */}
     </div>

     
  )
}

export default Login